require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/core-js/2.4.1/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 173
// module chunks = 0